import styled from 'styled-components';
import { Checkbox, Flex } from '@chakra-ui/react';

import React, { useEffect, useRef, InputHTMLAttributes } from 'react';
import { useField } from '@unform/core';
import './style.css';

export const CheckboxComp = styled(Checkbox)`
  margin-bottom: 21px;

  .chakra-checkbox__control {
    box-shadow: none !important;
    border: 2px solid #333;

    height: 18px;
    width: 18px;

    &[data-checked] {
      border: 1px solid ${({ theme }) => theme.colors.tertiary};
      background-color: ${({ theme }) => theme.colors.tertiary};
    }
  }

  .chakra-checkbox__label {
    margin-bottom: auto;
    margin-top: auto;
    margin-left: 12px;

    height: 23px;

    font-size: 14px;
    &[data-checked] {
      font-weight: bold;
      color: ${({ theme }) => theme.colors.tertiary};
    }
  }
`;

// ======================================

export const LabelCheckBox = styled.label<{ isChecked: boolean }>`
  .chakra-checkbox__control {
    box-shadow: none !important;
    border: 2px solid #333;

    height: 18px;
    width: 18px;

    &[data-checked] {
      border: 1px solid ${({ theme }) => theme.colors.tertiary};
      background-color: ${({ theme }) => theme.colors.tertiary};
    }
  }

  &[data-checked] {
    font-weight: bold;
    color: ${({ theme }) => theme.colors.tertiary};
  }

  font-weight: ${({ isChecked }) => (isChecked ? 'bold' : 'normal')};
  color: ${({ theme, isChecked }) => (isChecked ? theme.colors.tertiary : 'black')};

  input[type='checkbox']:checked {
    color: red;
  }

  input[type='checkbox'] {
    border: 1px solid ${({ theme }) => theme.colors.tertiary} !important;
    background-color: ${({ theme }) => theme.colors.tertiary} !important;
  }
`;

export const FlexChakra = styled(Flex)`
  gap: 1rem;
  align-items: center;
`;

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  options: {
    id: string;
    value: string;
    label: string;
  }[];
}

export const CheckboxInput: React.FC<Props> = ({ name, options, ...rest }) => {
  const inputRefs = useRef<HTMLInputElement[]>([]);
  const { fieldName, registerField, defaultValue = [] } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs.current,
      getValue: (refs: HTMLInputElement[]) => {
        return refs.filter(ref => ref.checked).map(ref => ref.value);
      },
      clearValue: (refs: HTMLInputElement[]) => {
        refs.forEach(ref => {
          ref.checked = false;
        });
      },
      setValue: (refs: HTMLInputElement[], values: string[]) => {
        refs.forEach(ref => {
          if (values.includes(ref.id)) {
            ref.checked = true;
          }
        });
      },
    });
  }, [defaultValue, fieldName, registerField]);

  return (
    <div className="checkbox-container">
      {options.map(option => (
        <label htmlFor={option.id} key={option.id}>
          <input
            defaultChecked={defaultValue.includes(option.id)}
            ref={ref => {
              inputRefs.current.push(ref as HTMLInputElement);
            }}
            value={option.value}
            type="checkbox"
            id={option.id}
            {...rest}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};
